import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';
import { getDollarFormat } from 'utils/helpers';

const Body = ({ uncountedReport, endDate, beginDate }) => (
    <React.Fragment>
        {
            uncountedReport.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    {
                        uncountedReport.length > 0 &&
                        <div className="table-responsive">
                            {
                                uncountedReport.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-2" key={index}>
                                            <div className="col-lg-12 title_th">
                                            </div>{/* row - Date */}
                                            <div className="row col-lg-12 daily_cash">
                                                <div className="row col-lg-2 col-md-2 col-sm-12 col-xs-12 m-0 p-0">
                                                    <label>Branch</label>
                                                    <h3 className="m-0 grey-text">{item.branchName}</h3>
                                                </div>
                                                <div className="row col-lg-3 col-md-3 col-sm-12 col-xs-12 m-0 p-0">
                                                    <label className="p-0">Product Name</label>
                                                    <h3 className="m-0 p-0 pr-2 grey-text">{item.productName}</h3>
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                        <span className="m-0 grey-text"><label>SKU: </label> {item.sku}</span>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                        <span className="m-0 grey-text"><label>Category: </label> {item.categoryName}</span>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                        <span className="m-0 grey-text"><label>Subcategory: </label> {item.subCategoryName}</span>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                        <span className="m-0 grey-text"><label>CategoryParent: </label> {item.categoryParent}</span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 m-0 p-0">
                                                    <label>Last Counted Warehouse Type</label>
                                                    <h3 className="m-0 grey-text">{item.warehouseType}</h3>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 m-0 p-0">
                                                    <label>Last Counted</label>
                                                    <h3 className="m-0 grey-text">{item.lastCounted}</h3>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-xs-12 m-0 p-0">
                                                    <label>Days Since Count</label>
                                                    <h3 className="m-0 grey-text">{item.daysSinceCount != 99999 ? item.daysSinceCount : "N/A"}</h3>
                                                </div>
                                                <div className="row col-lg-2 col-md-2 col-sm-12 col-xs-12 m-0 p-0">
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                        <label>Current QOH</label>
                                                        <h3 className="m-0 grey-text">{item.qoh}</h3>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                        <label>Weighted Avg Cost</label>
                                                        <h3 className="m-0 grey-text">{getDollarFormat(item.weightedAvgCost)}</h3>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                        <label>Total Value</label>
                                                        <h3 className="m-0 grey-text">{getDollarFormat(item.totalValue)}</h3>
                                                    </div>
                                                </div>
                                            </div>{/* Column Icons */}
                                        </div>
                                    );
                                })
                            }
                        </div>
                    }
                </div>
        }
    </React.Fragment>
);

export default Body;


